import DialogModal from '@/components/DialogModal';
import { useTranslation } from 'react-i18next';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: () => void;
};

function ConfirmDeleteBlockModal({ isOpen, onClose, onSubmit }: Props) {
  const { t } = useTranslation('ConfirmDeleteBlockModal');
  return (
    <DialogModal
      isOpen={isOpen}
      onCancel={onClose}
      title={t('title.confirm')}
      message={t('messages.deleteBlock')}
      onConfirm={onSubmit}
      confirmText={t('buttons.moveActionDeleteBlock')}
      confirmVariant="danger"
    />
  );
}

export default ConfirmDeleteBlockModal;
